/** Язык интерфейса кассы: рабочий контур кассира на двух языках.
 *  Переключатель в ⚙; чек имеет свой независимый язык. */
export type PosLang = 'ru' | 'kk';

const D: Record<PosLang, Record<string, string>> = {
  ru: {
    pay: 'Оплата', table: 'Стол', hold: 'Отложить', cancel: 'Отмена',
    guest: 'Гость', discount: 'Скидка', split: 'Разделить', promo: 'Промокод друга',
    back: 'Назад', confirm: 'Оплатить', due: 'К оплате', change: 'Сдача',
    cash: 'Наличные', card: 'Карта', shift: 'Смена', total: 'Итого',
    precheck: 'Пречек', kitchen: 'На кухню', clear: 'Убрать',
    chooseTable: 'Выбрать стол', remaining: 'Осталось внести',
    splitLong: 'Разделить чек по позициям', guestByPhone: 'Гость по телефону',
    payN: 'Оплатить',
    tables: 'Столы', discountTitle: 'Скидка на чек', removeDiscount: 'Убрать скидку',
    apply: 'Применить', tooBig: 'Скидка больше подытога',
    guestPhone: 'Телефон гостя', find: 'Найти', save: 'Сохранить', note: 'Заметка',
    opIn: 'Внесение записано.', opOut: 'Изъятие записано.',
    codeOk: 'Код принят: скидка', codeBad: 'Код не подошёл: не найден, уже использован или истёк.',
    needNet: 'Проверка кода требует связи.',
    callWaiter: 'официант', callBill: 'счёт',
    stopTitle: 'Стоп-лист точки', stopFind: 'Найти позицию…',
    stopStop: 'Стоп', stopReturn: 'Вернуть',
    stopHint: 'Стоп до конца дня — в полночь снимется сам. Офис видит всё то же.',
  },
  kk: {
    pay: 'Төлем', table: 'Үстел', hold: 'Кейінге', cancel: 'Болдырмау',
    guest: 'Қонақ', discount: 'Жеңілдік', split: 'Бөлу', promo: 'Дос промокоды',
    back: 'Артқа', confirm: 'Төлеу', due: 'Төлеуге', change: 'Қайтарым',
    cash: 'Қолма-қол', card: 'Карта', shift: 'Ауысым', total: 'Барлығы',
    precheck: 'Пречек', kitchen: 'Асханаға', clear: 'Алып тастау',
    chooseTable: 'Үстел таңдау', remaining: 'Қалғаны',
    splitLong: 'Чекті бөлу', guestByPhone: 'Қонақ телефоны бойынша',
    payN: 'Төлеу',
    tables: 'Үстелдер', discountTitle: 'Чекке жеңілдік', removeDiscount: 'Жеңілдікті алу',
    apply: 'Қолдану', tooBig: 'Жеңілдік аралық жиыннан көп',
    guestPhone: 'Қонақ телефоны', find: 'Табу', save: 'Сақтау', note: 'Ескертпе',
    opIn: 'Салым жазылды.', opOut: 'Алу жазылды.',
    codeOk: 'Код қабылданды: жеңілдік', codeBad: 'Код жарамады: табылмады, қолданылған немесе мерзімі өткен.',
    needNet: 'Кодты тексеруге байланыс керек.',
    callWaiter: 'даяшы', callBill: 'шот',
    stopTitle: 'Нүкте стоп-парағы', stopFind: 'Позиция іздеу…',
    stopStop: 'Стоп', stopReturn: 'Қайтару',
    stopHint: 'Күн соңына дейін — түн ортасында өзі алынады.',
  },
};

export function posLang(): PosLang {
  return (localStorage.getItem('dastarhan.posLang') as PosLang) ?? 'ru';
}

export function tt(key: string): string {
  return D[posLang()]![key] ?? D.ru[key] ?? key;
}
